<script lang="ts">
    import { onMount } from "svelte";
	import { get } from "svelte/store";
    import { storeActus, storeActu, Actu } from "../scripts/classes/actu";
	import { ACTU_CATEGORY_EVENEMENT, ACTU_CATEGORY_PTCE, EVENT_DISTANCIAL, EVENT_PRESENTIAL } from "../scripts/constant"
    import { redirectTo } from "../scripts/router1";
	import { idPageActu } from "../scripts/router2";

	export let inActu: Actu;
	let isEvent: boolean = false;
	let isPTCE: boolean = false;
	let isPresential: boolean = false;
	let isDistancial: boolean = false;
	let day: string;
	let monthLong: string;
	let monthShort: string;
	let year: string;

	onMount(async() => {
		extractDateInfos(inActu.date);
		if (inActu.actu_category == ACTU_CATEGORY_EVENEMENT) {
			isEvent = true;
		}
		if (inActu.actu_category == ACTU_CATEGORY_PTCE) {
			isPTCE = true;
		}
		if (inActu.event_type == 2) {
			isPresential = true;
		}
		if (inActu.event_type == 3) {
			isDistancial = true;
		}
	})

	function extractDateInfos(inDate: string) {
		const dateArray = inDate.split("-");
		year = dateArray[0];
		day = dateArray[2];
		const date = new Date(parseInt(year), parseInt(dateArray[1]) - 1, parseInt(day));  // 2009-11-10
		monthShort = date.toLocaleString('default', { month: 'short' });
		monthLong = date.toLocaleString('default', { month: 'long' });
		day = parseInt(day).toString();
	}

	function selectActu() {
		const filteredActus = get(storeActus).filter((actu) => actu.id == inActu.id)[0];
		if (filteredActus != undefined && filteredActus != "") {
			storeActu.set(filteredActus);
			redirectTo(idPageActu, "?id="+inActu.id);    
		}
	}

</script>

<style lang="scss">

	.actuinsight {
		min-width: 200px;
		min-height: 300px;
		max-width: 300px;
		max-height: 400px;
		width: 200px;
		height: 300px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		border: 1px solid $color_black;
		background-color: $color_white;
		font-family: 'Borna-Medium';
		font-size: 14px;
	}

	.catactu {
		&:hover {
			background-color: $color_primary;
		}
		&__pins {
			z-index: 100;
			margin-top: -20px;
			font-size: 29px;
			&__img {
				height: 40px;
				width: 150px;
			}
		}
		&__photo {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			&__img {
				object-fit: cover;
				object-position: 50% 0;
				height: 150px;
				width: 200px;
				&__ptce {
					margin-top: -31.5px;
				}
			}
		}
		&__patch {
			z-index: 100;
			margin-top: -10px;
			height: 20px;
			background-color: $color_grey;
			font-family: 'Borna-Medium';
			font-size: 12px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 2px 2px 2px 2px;
		}
		&__text {
			padding: 0px 10px 0px 10px;
			text-align: center;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
		&__title {
			padding: 10px 10px 0px 10px;
			text-align: center;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			font-family: 'Borna-Bold';
		}
	}

	.catevent {
		border-radius: 40px;
		&:hover {
			background-color: $color_primary;
		}
		&__presential {
			&:hover {
				background-color: $color_secondary;
			}
		}
		&__pins {
			margin-top: -20px;
			font-size: 29px;
		}
		&__date {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			height: 150px;
			width: 200px;
			margin-top: -31px;
			font-family: 'Borna-Medium';
			font-size: 35px;
			line-height: 1;
			text-align: center;
		}
		&__text {
			padding: 0px 10px 0px 10px;
			text-align: center;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
		&__title {
			padding: 10px 10px 0px 10px;
			text-align: center;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			font-weight: bold;
		}
		&__patch {
			padding: 0;
			margin-top: -10px;
			height: 20px;
			background-color: $color_grey;
			font-family: 'Borna-Medium';
			font-size: 12px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border-radius: 20px;
			padding: 2px 2px 2px 2px;
		}
	}

	@include large {
		.actuinsight {
			font-size: 14px;
			cursor: pointer;
		}

		.catactu {
			&__patch {
				font-size: 13px;
				padding: 6px 14px 6px 14px;
			}
		}

		.catevent {
			&__patch {
				font-size: 13px;
				padding: 6px 14px 6px 14px;
			}
			&__date {
				font-size: 28px;
			}
		}

	}

</style>

{#if isEvent}
<div class="actuinsight catevent" class:catevent__presential={isPresential} on:click={() => selectActu()} on:keydown={() => selectActu()}>
	{#if inActu.id != 0}
	{#if isPresential}
	<div class="catevent__pins">
		<img class="catactu__pins__img" alt="Présentiel" src="../assets/images/pins_presentiel.svg">	
	</div>
	{/if}
	{#if isDistancial}
	<div class="catevent__pins">
		<img class="catactu__pins__img" alt="Distanciel" src="../assets/images/pins_distanciel.svg">	
	</div>
	{/if}
	<div class="catevent__date">
		{day}&nbsp;{monthLong}<br>{year}
	</div>
	{#if (inActu.place == "")}
	<div class="catevent__patch">Distanciel</div>
	{:else}
	<div class="catevent__patch">{inActu.place}</div>
	{/if}
	<div class="catevent__title">
		{inActu.title}
	</div>
	<div class="catevent__text">
		{inActu.subtitle}
	</div>
	{/if}
</div>
{:else}
<div class="actuinsight catactu" on:click={() => selectActu()} on:keydown={() => selectActu()}>
	{#if inActu.id != 0}
	<div class="catactu__photo">
		{#if isPTCE}
		<div class="catactu__pins">
			<img class="catactu__pins__img" alt="PTCE" src="../assets/images/pins_ptce.svg">	
		</div>
		{/if}
		<img class="catactu__photo__img" class:catactu__photo__img__ptce={isPTCE} alt={inActu.title} src="../assets/images/actus/{inActu.id}_{inActu.photo}">
		<div class="catactu__patch">{day}&nbsp;{monthShort}&nbsp;{year}</div>
	</div>
	<div class="catactu__title">
		{inActu.title}
	</div>
	<div class="catactu__text">
		{inActu.subtitle}
	</div>
	{/if}
</div>
{/if}
